import { render, staticRenderFns } from "./ExamInfo.vue?vue&type=template&id=59dc304e&scoped=true&"
import script from "./ExamInfo.vue?vue&type=script&lang=js&"
export * from "./ExamInfo.vue?vue&type=script&lang=js&"
import style0 from "./ExamInfo.vue?vue&type=style&index=0&id=59dc304e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dc304e",
  null
  
)

export default component.exports